'use strict';

import {
  ScaleControl
} from './Controls/ScaleControl.js'
import {
  EditControl
} from './Controls/EditControl.js'
import {
  FontControl
} from './Controls/FontControl.js'
import {
  HideControl
} from './Controls/HideControl.js'
import {
  SelectControl
} from './Controls/SelectControl.js'
import {
  NationalPrefixControl
} from './Controls/NationalPrefixControl.js'

export class Controls {
  constructor(label, type, element, svg) {
    this.$controls = document.createElement('div')
    this.$controls.classList.add('si_controls')
    this.$controls.classList.add(`si_controls--${type}`)

    const accordeon = document.createElement('input')
    accordeon.setAttribute('type', 'checkbox')
    accordeon.setAttribute('id', `accordeon--${label.slice(0,2)+''+label.slice(-3)}`)
    //console.log("!!!!!!! " + element.parent().node.id)
    const title = document.createElement('label')
    title.setAttribute('for', `accordeon--${label.slice(0,2)+''+label.slice(-3)}`)
    title.classList.add('si_controls__title')
    title.innerHTML = `${label}`
    
    var tempId = element.parent().node.id;
    if(tempId == ''){
      tempId = element.parent().parent().node.id;
    }
    if (document.documentElement.lang == "en") {
      
      switch (tempId) {
        case 'fname':
          title.innerHTML = `First name`
          break;
        case 'lname':
          title.innerHTML = `Last name`
          break;
        case 'name':
          title.innerHTML = `Name`
          break;
        case 'title':
          title.innerHTML = `Title`
          break;
        case "bphone":
          title.innerHTML = `Phone`
          break;
        case "bmail":
          title.innerHTML = `Email`
          break;
        case "photo":
          title.innerHTML = `Photo`
          break;
        case "burl":
          title.innerHTML = `Website`
          break;
        case 'aname':
          title.innerHTML = `Agency's name`
          break;
        case 'aphone':
          title.innerHTML = `Agency's phone`
          break;
        case 'atitle':
          title.innerHTML = `Agency's title`
          break;
        case "input1":
          title.innerHTML = `Field 1`
          break;
        case "input2":
          title.innerHTML = `Field 2`
          break;
        case "input3":
          title.innerHTML = `Field 3`
          break;
        case "input4":
          title.innerHTML = `Field 4`
          break;
        case "input5":
          title.innerHTML = `Field 5`
          break;
        //BIS
        case 'fnamebis':
          title.innerHTML = `First name /back`
          break;
        case 'lnamebis':
          title.innerHTML = `Last name /back`
          break;
        case 'namebis':
          title.innerHTML = `Name /back`
          break;
        case 'titlebis':
          title.innerHTML = `Title /back`
          break;
        case "bphonebis":
          title.innerHTML = `Phone /back`
          break;
        case "bmailbis":
          title.innerHTML = `Email /back`
          break;
        case "photobis":
          title.innerHTML = `Photo /back`
          break;
         case "photobis":
          title.innerHTML = `Photo /back`
          break;
        case "burlbis":
          title.innerHTML = `Website /back`
          break;
        case 'anamebis':
          title.innerHTML = `Agency's name /back`
          break;
        case 'aphonebis':
          title.innerHTML = `Agency's phone /back`
          break;
        case 'atitlebis':
          title.innerHTML = `Agency's title /back`
          break;
        case "input1bis":
          title.innerHTML = `Field 1 /back`
          break;
        case "input2bis":
          title.innerHTML = `Field 2 /back`
          break;
        case "input3bis":
          title.innerHTML = `Field 3 /back`
          break;
        case "input4bis":
          title.innerHTML = `Field 4 /back`
          break;
        case "input5bis":
          title.innerHTML = `Field 5 /back`
          break;
      }
    }else if(document.documentElement.lang == "fr"){
      switch (tempId) {
        case 'fname':
          title.innerHTML = 'Prénom'
          break;
        case 'name':
          title.innerHTML = 'Nom'
          break;
        case 'lname':
          title.innerHTML = `Nom`
          break;
        case 'title':
          title.innerHTML = 'Titre'
          break;
        case "bphone":
          title.innerHTML = `Téléphone`
          break;
        case "bmail":
          title.innerHTML = `Courriel`
          break;
        case "photo":
          title.innerHTML = `Photo`
          break;
        case "burl":
          title.innerHTML = `Site internet`
          break;
        case "aname":
          title.innerHTML = `Nom d'agence`
          break;
        case 'atitle':
          title.innerHTML = `Titre d'agence`
          break;
        case 'aphone':
          title.innerHTML = `Téléphone d'agence`
          break;
        case "input1":
          title.innerHTML = `Champ 1`
          break;
        case "input2":
          title.innerHTML = `Champ 2`
          break;
        case "input3":
          title.innerHTML = `Champ 3`
          break;
        case "input4":
          title.innerHTML = `Champ 4`
          break;
        case "input5":
          title.innerHTML = `Champ 5`
          break;
        //BIS
        case 'fnamebis':
          title.innerHTML = 'Prénom /verso'
          break;
        case 'namebis':
          title.innerHTML = 'Nom /verso'
          break;
        case 'lnamebis':
          title.innerHTML = `Nom /verso`
          break;
        case 'titlebis':
          title.innerHTML = 'Titre /verso'
          break;
        case "bphonebis":
          title.innerHTML = `Téléphone /verso`
          break;
        case "bmailbis":
          title.innerHTML = `Courriel /verso`
          break;
        case "photobis":
          title.innerHTML = `Photo /verso`
          break;
        case "burlbis":
          title.innerHTML = `Site internet /verso`
          break;
        case "anamebis":
          title.innerHTML = `Nom d'agence /verso`
          break;
        case 'aphonebis':
          title.innerHTML = `Téléphone d'agence /verso`
          break;
        case 'atitlebis':
          title.innerHTML = `Titre d'agence /verso`
          break;
        case "input1bis":
          title.innerHTML = `Champ 1 /verso`
          break;
        case "input2bis":
          title.innerHTML = `Champ 2 /verso`
          break;
        case "input3bis":
          title.innerHTML = `Champ 3 /verso`
          break;
        case "input4bis":
          title.innerHTML = `Champ 4 /verso`
          break;
        case "input5bis":
          title.innerHTML = `Champ 5 /verso`
          break;
      }
    }

    const content = document.createElement('div')
    content.classList.add('ac-content')

    this.$controls.appendChild(accordeon)
    this.$controls.appendChild(title)
    this.$controls.appendChild(content)

    this.controls = {}

    if (element.attr('si:can-hide') == "true") {
      this.controls.hideControl = new HideControl(element, svg)
      content.appendChild(this.controls.hideControl.getElement())
    }
    if (element.attr('si:can-edit') == "true") {
      this.controls.editControl = new EditControl(element, svg)
      content.appendChild(this.controls.editControl.getElement())

      if (element.attr('si:phone-format') == "true") {
        this.controls.NationalPrefixControl = new NationalPrefixControl(element, this.controls.editControl.$input)
        content.appendChild(this.controls.NationalPrefixControl.getElement())
      }
    }
    if (element.attr('si:can-select') == "true") {
      this.controls.selectControl = new SelectControl(element)
      content.appendChild(this.controls.selectControl.getElement())
    }
    if (element.attr('si:can-font-resize') == "true") {
      this.controls.fontControl = new FontControl(element, svg)
      content.appendChild(this.controls.fontControl.getElement())
    }

    if (element.attr('si:can-scale') == "true") {
      this.controls.scaleControl = new ScaleControl(element, svg)
      content.appendChild(this.controls.scaleControl.getElement())

      // Create reset button
      const resetControl = document.createElement('div')
      resetControl.classList.add('si_controls__control')
      resetControl.classList.add('si_control')
      resetControl.classList.add('si_control--reset')

      const resetInput = document.createElement('button')
      resetInput.classList.add('si_control__button')
      resetInput.classList.add('si_button')
      resetInput.classList.add('si_button--reset')
      resetInput.setAttribute('type', 'button')
      resetInput.innerHTML = "Reset"
      resetControl.appendChild(resetInput)

      content.appendChild(resetControl)

      resetControl.addEventListener('click', this.reset.bind(this))
    }


    element.reset = this.reset.bind(this)

    return this
  }

  getElement() {
    return this.$controls
  }

  reset() {
    for (const control in this.controls) {
      this.controls[control].reset()
    }

    return this
  }
}
